import React, { useEffect, useState } from "react";
import axios from "axios";
import { getOptimizedThumbnail } from "./frontendUtils.js";
import { Link } from "react-router-dom";
import CustomCarousel from "./CustomCarousel";  

const RelatedArticles = ({ year, month, day, title, supportsAvif }) => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchRelatedArticles = async (retries = 3) => {
      try {
          const response = await axios.get('/api/relatedarticles');
          const validArticles = response.data.filter(article => 
              article.pageUrl !== '' && article.thumbnail !== ''
          );

          // Optimize thumbnails for each article
          const optimizedArticles = await Promise.all(
            validArticles.map(async (article) => {
                const optimizedThumbnail = await getOptimizedThumbnail(article.thumbnail, 200, supportsAvif);
                return { ...article, optimizedThumbnail };
            })
          );

          setArticles(optimizedArticles);
      } catch (error) {
          if (retries > 0) {
              setTimeout(() => fetchRelatedArticles(retries - 1), 2000);
          } else {
              //console.error(`Error fetching related articles: ${error}`);
          }
      }
    };

    fetchRelatedArticles();
}, [year, month, day, title]); 

  if (!Array.isArray(articles) || articles.length === 0) {
    return null;
  }

  return (
    <div className="slider-container ml-5 mr-5 border-t pt-4">
      <CustomCarousel colsMobile={2} colsDesktop={4}> 
        {articles.map((article) => (
           <div key={article.id}>
            <div className="p-2 flex flex-col justify-between overflow-hidden">

              <Link to={`${article.pageUrl}`}>

                <div className="w-full h-[110px] border-b border-gray-300 overflow-hidden">

                  <picture>
                    {article.optimizedThumbnail?.avifMobile && (
                      <source srcSet={article.optimizedThumbnail.avifMobile} type="image/avif" />
                    )}
                    {article.optimizedThumbnail?.webp && (
                      <source srcSet={article.optimizedThumbnail.webp} type="image/webp" />
                    )}
                    <img
                      src={
                        article.optimizedThumbnail?.fallback ||
                        article.optimizedThumbnail?.webp ||
                        article.thumbnail
                      }
                      alt={article.imageCaption}
                      className="w-full h-auto object-cover object-center"
                      width={200}
                      height={
                        article.thumbnailWidth && article.thumbnailHeight
                          ? (200 * article.thumbnailHeight) / article.thumbnailWidth
                          : 120
                      }
                      style={{
                        aspectRatio: `${article.thumbnailWidth || 200} / ${article.thumbnailHeight || 120}`,
                      }}
                      loading="lazy"
                    />
                  </picture>

                </div>

                <div>
                  <h2
                    style={{
                      fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
                      color: "var(--text-color)",
                      fontSize: "18px",
                      lineHeight: "1.35em",
                      fontWeight: "500",
                      wordWrap: "break-word", //Ensures long words wrap
                      whiteSpace: "normal", //Allows text to wrap instead of staying in one line
                      overflow: "hidden", //Prevents text from overflowing its container
                      textOverflow: "ellipsis", //Optional: Adds "..." if it still overflows
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2, //Limits title to 2 lines before cutting off
                    }}
                    className="font-bold mb-2 pt-2 "
                  >
                    {article.title}
                  </h2>

                </div>
              </Link>
            </div>
          </div>
        ))}
      </CustomCarousel>
    </div>
  );
};

export default RelatedArticles;
